module.exports = __webpack_public_path__ + "static/media/contrato-imagen-min.cec2e15c.png";